import '@bayesprep/shared-ui/errors/errors.css';
import { ImageAccessProvider } from '@bayesprep/shared-ui/images';
import imageApi from './lib/api';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/globals.css';
import 'katex/dist/katex.min.css';

const resolveImage = async (key: string, signal: AbortSignal) => {
  const response = await imageApi.get('/core/images/content', { params: { imageUrl: key }, responseType: 'blob', signal });
  return response.data;
};
const getImageIdentity = () => {
  const token = localStorage.getItem('token');
  return token ? token + '|' + (localStorage.getItem('tenantCode') || '') : '';
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ImageAccessProvider resolveImage={resolveImage} getIdentity={getImageIdentity}>
        <App />
      </ImageAccessProvider>
    </BrowserRouter>
  </React.StrictMode>
);
